/** 标签操作类型 */
export type TagsActionTypes = 'add' | 'edit' | 'delete' | 'create';

/** 下拉项类型 */
export type OptionsTypes = {
  value: string;
  label?: string;
  text: string;
};

/** 标签类型 */
export type TagsTypes = {
  tag: string;
  id: number;
};

/** from来源枚举：仅用于获取来源国际化key使用 */
export enum SourceEnum {
  /** li-pass导入联系人 */
  LI_PASS = 'LI-PASS',
  /** data-brain导入联系人 */
  DATA_BRAIN = 'IN-GAME',
  /** 文件上传联系人 */
  FILE = 'File',
  /** 单独添加联系人 */
  SINGLE_ADD = 'Manual-filled in',
  /** 工具上传 */
  TOOL = 'Tools',
  /** 工具上传 */
  TOOLS = 'tools',
  /** api导入联系人 */
  API = 'API',
  /** Data Science Team */
  DATA_SCIENCE_TEAM = 'DataScienceTeam',
  /** LEVEL INFINITE PASS订阅 */
  NEWSLETTER_SIGN_UP = 'newsletter sign up',
  /** 注册表单 */
  SIGN_UP_FORM = 'sign up form',
  /** 业务关联组内同步 */
  ASSOCIATE_GROUP = 'associate_group',
  // /** 管理端内 - 标签管理列表 */
  // TAG_LIST = 'tag_list',
  /** whatsapp */
  WHATSAPP = 'whatsapp',
  /** 联系人详情页 */
  DETAILS = 'detail',
  /** 旅程投递的二次确认 */
  OPTIN = 'optIn',
  /** 旅程 */
  JOURNEY = 'journey',
  /** 官网招募 */
  RECRUIT = 'recruit',
  /** 测试邀请 */
  PLAYTEST_HUB = 'Playtest_hub',
  /** Player Network：三方账号（渠道账号） */
  PN_THIRD_PARTY = 'PN_thirdParty',
  /** Player Network：业务品牌账号(gcp studio 环境) */
  PN_GCP_LIPASS = 'PN_GcpLiPass',
  /** Player Network：业务品牌账号(普通环境) */
  PN_LIPASS = 'PN_LiPass',
  /** 玩家验证 */
  PLAYER_VERIFICATION = 'PlayerVerification',
}

// 接口返回的时间线来源标识信息
export const enum ApiSourceEnum {
  /** 手动添加联系人 */
  MANUAL_FILED_IN = 'Manual-filled in',
  /** 通过文件上传联系人 */
  FILE = 'File',
  /** 通过LI PASS */
  API_LI_PASS = 'API-LI-PASS',
  /** 通过IN GAME */
  API_IN_GAME = 'API-IN-GAME',
  /** 通过API- */
  API_XXX = 'API-XXX',
  /** 通过tools */
  TOOL = 'Tools',
  /** 通过tools */
  TOOLS = 'tools',
  /** 通过落地页 */
  PLAYER = 'player',
  /** 通过OPT-IN落地页(玩家二次确认订阅)) */
  PLAYER_OPT_IN = 'player_opt_in',
  /** 通过管理端 */
  CONSOLE = 'console',
  /** Data Science Team */
  DATA_SCIENCE_TEAM = 'Data Science Team',
  /** LEVEL INFINITE PASS订阅 */
  NEWSLETTER_SIGN_UP = 'newsletter sign up',
  /** 注册表单 */
  SIGN_UP_FORM = 'sign up form',
  /** 业务关联组内同步 */
  ASSOCIATE_GROUP = 'associate_group',
  /** whatsapp */
  WHATSAPP = 'whatsapp',
  /** 联系人详情页 */
  DETAILS = 'detail',
  /** 旅程投递的二次确认 */
  OPTIN = 'optIn',
  /** 旅程 */
  JOURNEY = 'journey',
  // 绑定discord账号
  DISCORD = 'bindDiscord',
  // 绑定steam账号
  STEAM = 'bindSteam',
  // 联系人被邀请
  TESTER = 'tester',
  // Discord账号 - 联系人信息合并
  DISCORD_CONTACT_MERGE = 'mergeDiscord',
  // Steam账号 - 联系人信息合并
  STEAM_CONTACT_MERGE = 'mergeSteam',
  /** 官网招募 */
  RECRUIT = 'recruit',
  /** 测试邀请 */
  PLAYTEST_HUB = 'Playtest_hub',
  /** Player Network：三方账号（渠道账号） */
  PN_THIRD_PARTY = 'PN_thirdParty',
  /** Player Network：业务品牌账号(gcp studio 环境，可能存在具体品牌名称) */
  PN_GCP_LIPASS = 'PN_GcpLiPass',
  /** Player Network：业务品牌账号(普通环境，无具体品牌名称) */
  PN_LIPASS = 'PN_LiPass',
  /** 玩家验证 */
  PLAYER_VERIFICATION = 'PlayerVerification',
}

// 标签操作类型枚举
export enum TagsActionEnum {
  ADD = 'add',
  EDIT = 'edit',
  DEL = 'delete',
  CREATE = 'create',
}

/** 页面类型 */
export enum PageTypeEnum {
  DETAILS = 'details',
  ADD_OR_EDIT = 'addOrEdit',
}

/** 邮箱 WhatsApp订阅状态 */
export enum SubscriptionTypeEnum {
  /** 邮箱 */
  EMAIL = 'isReceiveEmail',
  /** WhatsApp */
  WHATSAPP = 'wuidSubscribeState',
}

// steam账号信息
export interface SteamContent {
  steam?: {
    steam_id?: string;
    nick_name?: string;
    email?: string;
  };
}

// apiType枚举
export enum ApiTypeEnum {
  DISCORD_BIND = '33', // 绑定/换绑Discord
  STEAM_BIND = '34', // 绑定/换绑Steam
  USER_INVITED_TO_TEST = '35', // 用户被邀请进入测试
  USER_ACCEPTED_INVITATION = '36', // 用户接受邀请
  SEND_RESOURCE_CODE_EMAIL = '37', // 向用户发送资源码邮件
  DISCORD_CONTACT_MERGE = '38', // Discord账号 - 联系人信息合并
  STEAM_CONTACT_MERGE = '39', // Steam账号 - 联系人信息合并
}

export enum PlaytimeStatusEnum {
  /** 未公开，或游戏库为空 */
  PRIVATE = 0,
  /** 游戏库不为空，但无指定游戏， 或有指定游戏但未启动过游戏 */
  PUBLIC = 1,
  /** 有指定游戏 */
  AVAILABLE = 2,
}

export enum WishlistStatusEnum {
  /** 用户未公开个人资料，或wishlist为空 */
  PRIVATE = 0,
  /** wishlist不为空，但无指定游戏 */
  NOT_ADDED = 1,
  /** 有指定游戏 */
  ADDED = 2,
}

export enum NightTimePermissionStatusEnum {
  /** 允许*/
  ALLOW = 1,
  /** 不允许*/
  NOT_ALLOW = 2,
  /** 未知 */
  UNKNOWN = 0,
}

/** 情感分析存在状态 */
export enum SentimentExistEnum {
  /** 不存在 */
  NOT_EXIST = 0,
  /** 存在 */
  EXIST = 1,
}

